export const renderTime = (h, m) => {
  if (Number.isNaN(h) || h === null || h === undefined) {
    return '';
  }

  const hString = h < 10 ? `0${h}` : h.toString();

  // eslint-disable-next-line no-nested-ternary
  const mString = Number.isNaN(m) || m === null || m === undefined ? '00' : m < 10 ? `0${m}` : m.toString();

  return `${hString}:${mString}`;
};

export const weekDays = [
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 7 },
];
